import { initialiseInstanceComponents } from "../../shared/instanceComponentInitialiser";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { PagingCarouselGalleryWithZoomButton } from "./pagingCarouselGalleryWithZoomButton";

export function initialisePagingCarouselGalleryWithZoomButton() {
    initialiseInstanceComponents<PagingCarouselGalleryWithZoomButton>(PagingCarouselGalleryWithZoomButton,
        HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGalleryWithZoomButton.PagingCarouselGalleryWithZoomButton),
        pagingCarouselGalleryWithZoomButtonFactory);
}

function pagingCarouselGalleryWithZoomButtonFactory(currentElement: Element): void {
    let newPagingCarouselGalleryWithZoomButton = new PagingCarouselGalleryWithZoomButton(currentElement);
    (<any>window)[currentElement.getAttribute(AttributeEnums.PagingCarouselGalleryWithZoomButton.PagingCarouselGalleryWithZoomButton) + 'PagingCarouselGalleryWithZoomButton'] = newPagingCarouselGalleryWithZoomButton;
}